import Productos from './productos';
import SedeDetalle from './sedeDetalle';
import Mensajes from '../../../../../base/components/mensajes';

class MisProductosBeneficiarios extends React.Component {
    constructor() {
        super();
        this.state = {
            key: 1,
            productsActiveKey: 0,
            beneficiariesActiveKey: 0,
            specialitiesActiveKey: 0,
            beneficiaries: [],
            showBeneficiariesTab: false,
            benefiariesServiceErrorMessage: ''
        };
        this.tabSelect = this.tabSelect.bind(this);
        this.beneficiariesHandleSelect = this.beneficiariesHandleSelect.bind(this);
        this.styledTabs = this.styledTabs.bind(this);
    }

    componentDidMount() {
        let beneficiaries = JSON.parse(JSON.stringify(this.state.beneficiaries));
        let service = this.props.userInfo.typeUser == 'EP' ? 'BeneficiariosUsuarioPBS' : 'BeneficiariosUsuarioPC';
        const getBeneficiaries = new ServicioProxy(service + '?tipoDocumento=' + (this.props.userInfo.TipoIdentificacion) + '&numeroDocumento=' + (this.props.userInfo.LegalID));
        getBeneficiaries.getElements('POST', {}).then((response) => {
            let data = JSON.parse(response);

            /*data = {
                "Beneficiarios": [],
                "Error": {
                    "CodigoStatusError": "401",
                    "MensajeError": "The remote server was not found: (401) Not found."
                }
            }*/

            if (!data.Error) {
                beneficiaries = data.Beneficiarios.map((beneficiary, index) => {
                    return {
                        id: index + 1,
                        documentType: beneficiary.TipoDeDocumento,
                        documentNumber: beneficiary.NumeroDeDocumento,
                        name: beneficiary.Nombre
                    }
                });
                if (beneficiaries.length) this.setState({ beneficiaries, showBeneficiariesTab: true });
            } else {
                this.setState({
                    showBeneficiariesTab: true,
                    benefiariesServiceErrorMessage: this.props.configurations['MensajeErrorServicioBeneficiarios']
                });
            }

        });
        setTimeout(() => { this.styledTabs(); }, 1000);
    }

    tabSelect(key) {
        this.setState({ key }, () => {
            this.styledTabs();
        });
    }

    beneficiariesHandleSelect(beneficiariesActiveKey) {
        this.setState({ beneficiariesActiveKey });
    }

    styledTabs() {
        const width = window.innerWidth;
        const tabs = document.querySelector('#products-beneficiaries-tabs ul.nav.nav-tabs');
        const tabList = tabs.getElementsByTagName("li");
        if (width <= 760) {
            if (tabList.length > 1) {
                const item1 = tabList[1].childNodes;
                const item0 = tabList[0].childNodes;
                if (this.state.key === 1) {
                    tabList[0].style.cssText = 'width: 60%; left: 20%;';
                    tabList[1].style.cssText = 'width: 20%; right: 0%';
                    item1[0].textContent = " ";
                    item1[0].innerHTML = '<i class="fa fa-chevron-right" aria-hidden="true"></i>';
                    item0[0].textContent = 'Mis Productos';
                } else {
                    tabList[1].style.cssText = 'width: 60%;left: 20%;';
                    tabList[0].style.cssText = 'width: 20%; left: 0%; ;';
                    item0[0].textContent = " ";
                    item0[0].innerHTML = '<i class="fa fa-chevron-left" aria-hidden="true"></i>';
                    item1[0].textContent = 'Beneficiarios';
                }
            }
        }
    }

    renderBeneficiaries() {
        return (
            <PanelGroup accordion className="cs-accordeon" id={'beneficiary-accordeon'} activeKey={this.state.beneficiariesActiveKey} onSelect={this.beneficiariesHandleSelect}>
                {this.state.beneficiaries.map((beneficiary, beneficiaryIndex) => {
                    return (
                        <Panel eventKey={beneficiary.id} key={beneficiary.id}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h5 className={(this.state.beneficiariesActiveKey - 1 == beneficiaryIndex ? 'active-title' : 'inactive-title')}>{beneficiary.name}</h5>
                                    <div className={'accordion-icon ' + (this.state.beneficiariesActiveKey - 1 == beneficiaryIndex ? 'active' : '')}>
                                        <i className={'fa ' + (this.state.beneficiariesActiveKey - 1 == beneficiaryIndex ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down')}></i>
                                    </div>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <Productos userInfo={{ TipoIdentificacion: beneficiary.documentType, LegalID: beneficiary.documentNumber }} beneficiaryIndex={beneficiaryIndex} plan={this.props.plan} configurations={this.props.configurations} />
                            </Panel.Body>
                        </Panel>
                    );
                })}
            </PanelGroup>
        );
    }

    render() {
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div className="cs-tabs-container">
                        <div>{ this.state.currentAlert }</div>
                        <Tabs activeKey={this.state.key} onSelect={this.tabSelect} id="products-beneficiaries-tabs">
                            <Tab eventKey={1} title="Mis Productos">
                                <div className="tab-container">
                                    <Productos userInfo={this.props.userInfo} plan={this.props.plan} configurations={this.props.configurations} />
                                </div>
                            </Tab>
                            {(this.state.beneficiaries.length > 0) || this.state.showBeneficiariesTab ?
                                <Tab eventKey={2} title="Beneficiarios">
                                    <div className="tab-container">
                                        <p>{ this.state.benefiariesServiceErrorMessage }</p>
                                        {this.renderBeneficiaries()}
                                    </div>
                                </Tab>
                                : null
                            }
                        </Tabs>
                    </div>
                </div>
            </div>
        );
    }
}

/******************** BUILD ********************/
const Tabs = ReactBootstrap.Tabs;
const Tab = ReactBootstrap.Tab;
const PanelGroup = ReactBootstrap.PanelGroup;
const Panel = ReactBootstrap.Panel;
/******************** BUILD ********************/

export default MisProductosBeneficiarios;


// WEBPACK FOOTER //
// ./salidaGraficaRed/miRedDeAtencion/otrosServiciosRedDeUrgencias/src/components/misProductosBeneficiarios.js